import React from 'react';
import './RealTimeAnalytics.scss';
import {useTranslation} from "react-i18next";

const RealTimeAnalytics = () => {
    const {t, i18n} = useTranslation();

    return (
        <section className={'bcw-driving-section'}>
            <div className={'bcw-driving-image'}>
                <img
                    alt='left'
                    className={i18n.language === "en" ? "bcw-main-img-01" : "bcw-main-img-01-ar"}
                    src={'https://eflow-static01.s3-us-west-2.amazonaws.com/media/phpXnl7yN.png'}
                />
            </div>

            <div className={'bcw-driving-info'}>
                <h1>{t('real_time')}</h1>
                <h1 className={'bcw-level_changes'}>{t('analytics')}</h1>

                <br/>
                <br/>

                <p className={'bcw-driving-info-text'}>{t('real_time_description')}</p>

                <br/>
                <br/>

                <a
                    className={'bcw-main-demo'}
                    onClick={
                        () => {
                            window.Calendly.initPopupWidget({url: 'https://calendly.com/eflow-demo'});
                        }
                    }
                >
                    {t('learn_more')}
                </a>
            </div>
        </section>
    );
};

export default RealTimeAnalytics;
